// import Vue from 'vue'
// import Select2 from 'v-select2-component'
// import DateRangePicker from 'vue2-daterange-picker'
// import { ValidationObserver, ValidationProvider } from 'vee-validate'
// import Select2MultipleControl from 'v-select2-multiple-component'
// import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// import Default from '../layout/Wrappers/defaultLayout.vue'
// import Login from '../layout/Wrappers/loginLayout.vue'
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import * as VueGoogleMaps from 'vue2-google-maps'
// import { GOOGLE_API_TOKEN } from '@/env.js'
// import VueLoadingOverlay from 'vue-loading-overlay'
// import NotiSuccess from '@/components/Modal/Noti-Success.vue'
// import NotiError from '@/components/Modal/Noti-Error.vue'
// import Multiselect from 'vue-multiselect'
// import AddImages from '@/components/Modal/Add-Images.vue'
// import DraggableTable from '@/components/draggable-table'
// import DateTimePicker from 'vue-bootstrap-datetimepicker'
// import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
// import VCalendar from 'v-calendar'
// import Card from '@/components/common/Card.vue'
// import Content from '@/components/common/Content.vue'
// import Status from '@/components/common/Status.vue'
// // import 'bootstrap/dist/css/bootstrap.css'
// // import 'bootstrap-vue/dist/bootstrap-vue.css'
// Vue.config.productionTip = false
// Vue.use(BootstrapVue)
// Vue.use(IconsPlugin)
// Vue.use(VCalendar)

// // Cấu hình default settings cho Select2
// const defaultSelect2Settings = {
//   language: {
//     searching: function () {
//       return 'Đang tìm kiếm...'
//     },
//     noResults: function () {
//       return 'Không tìm thấy kết quả'
//     },
//     inputTooShort: function () {
//       return 'Vui lòng nhập ít nhất 1 ký tự'
//     },
//     inputTooLong: function () {
//       return 'Vui lòng xóa bớt ký tự'
//     },
//     loadingMore: function () {
//       return 'Đang tải thêm kết quả...'
//     },
//     maximumSelected: function () {
//       return 'Bạn chỉ có thể chọn tối đa số mục này'
//     },
//   },
// }

// // Hàm merge deep settings
// function mergeDeep(target, source) {
//   const output = Object.assign({}, target)
//   if (isObject(target) && isObject(source)) {
//     Object.keys(source).forEach(key => {
//       if (isObject(source[key])) {
//         if (!(key in target)) {
//           Object.assign(output, { [key]: source[key] })
//         } else {
//           output[key] = mergeDeep(target[key], source[key])
//         }
//       } else {
//         Object.assign(output, { [key]: source[key] })
//       }
//     })
//   }
//   return output
// }

// function isObject(item) {
//   return item && typeof item === 'object' && !Array.isArray(item)
// }

// // Tạo wrapper component cho Select2 với default settings
// const Select2WithDefaults = {
//   name: 'Select2WithDefaults',
//   inheritAttrs: false,
//   props: {
//     value: null,
//     options: {
//       type: Array,
//       default: () => [],
//     },
//     settings: {
//       type: Object,
//       default: () => ({}),
//     },
//     disabled: {
//       type: Boolean,
//       default: false,
//     },
//     placeholder: {
//       type: String,
//       default: '',
//     },
//     id: {
//       type: String,
//       default: '',
//     },
//     name: {
//       type: String,
//       default: '',
//     },
//   },
//   computed: {
//     mergedSettings() {
//       const userSettings = this.settings || {}
//       return mergeDeep(defaultSelect2Settings, userSettings)
//     },
//   },
//   render(h) {
//     const props = {
//       value: this.value,
//       options: this.options,
//       settings: this.mergedSettings,
//       disabled: this.disabled,
//       placeholder: this.placeholder,
//       id: this.id,
//       name: this.name,
//     }
//     // Copy tất cả props khác từ $attrs nếu có
//     Object.keys(this.$attrs).forEach(key => {
//       if (!(key in props)) {
//         props[key] = this.$attrs[key]
//       }
//     })
//     return h(Select2, {
//       attrs: this.$attrs,
//       props: props,
//       on: this.$listeners,
//       scopedSlots: this.$scopedSlots,
//     })
//   },
// }

// // Tạo wrapper component cho Select2MultipleControl với default settings
// const Select2MultipleControlWithDefaults = {
//   name: 'Select2MultipleControlWithDefaults',
//   inheritAttrs: false,
//   props: {
//     value: null,
//     options: {
//       type: Array,
//       default: () => [],
//     },
//     settings: {
//       type: Object,
//       default: () => ({}),
//     },
//     disabled: {
//       type: Boolean,
//       default: false,
//     },
//     placeholder: {
//       type: String,
//       default: '',
//     },
//     id: {
//       type: String,
//       default: '',
//     },
//     name: {
//       type: String,
//       default: '',
//     },
//   },
//   computed: {
//     mergedSettings() {
//       const userSettings = this.settings || {}
//       return mergeDeep(defaultSelect2Settings, userSettings)
//     },
//   },
//   render(h) {
//     const props = {
//       value: this.value,
//       options: this.options,
//       settings: this.mergedSettings,
//       disabled: this.disabled,
//       placeholder: this.placeholder,
//       id: this.id,
//       name: this.name,
//     }
//     // Copy tất cả props khác từ $attrs nếu có
//     Object.keys(this.$attrs).forEach(key => {
//       if (!(key in props)) {
//         props[key] = this.$attrs[key]
//       }
//     })
//     return h(Select2MultipleControl, {
//       attrs: this.$attrs,
//       props: props,
//       on: this.$listeners,
//       scopedSlots: this.$scopedSlots,
//     })
//   },
// }

// Vue.component('DraggableTable', DraggableTable)
// Vue.component('ValidationObserver', ValidationObserver)
// Vue.component('Select2', Select2WithDefaults)
// Vue.component('select2', Select2WithDefaults) // Đăng ký cả kebab-case
// Vue.component('DateRanger', DateRangePicker)
// Vue.component('Datepicker', Datepicker)
// Vue.component('Select2MultipleControl', Select2MultipleControlWithDefaults)
// Vue.component('select2-multiple-control', Select2MultipleControlWithDefaults) // Đăng ký cả kebab-case
// Vue.component('ValidationProvider', ValidationProvider)
// Vue.component('DateRangePicker', DateRangePicker)
// Vue.component('VueLoadingOverlay', VueLoadingOverlay)
// Vue.component('NotiSuccess', NotiSuccess)
// Vue.component('NotiError', NotiError)
// Vue.component('AddImages', AddImages)
// Vue.component('default-layout', Default)
// Vue.component('login-layout', Login)
// Vue.component('multiselect', Multiselect)
// Vue.component('DateTimePicker', DateTimePicker)
// Vue.component('Card', Card)
// Vue.component('Content', Content)
// Vue.component('Status', Status)

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: GOOGLE_API_TOKEN,
//     libraries: 'places',
//   },
// })

import Vue from 'vue'
import Select2 from 'v-select2-component'
import DateRangePicker from 'vue2-daterange-picker'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Select2MultipleControl from 'v-select2-multiple-component'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Default from '../layout/Wrappers/defaultLayout.vue'
import Login from '../layout/Wrappers/loginLayout.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import { GOOGLE_API_TOKEN } from '@/env.js'
import VueLoadingOverlayCustom from './VueLoadingOverlayCustom.vue'
import NotiSuccess from '@/components/Modal/Noti-Success.vue'
import NotiError from '@/components/Modal/Noti-Error.vue'
import Multiselect from 'vue-multiselect'
import AddImages from '@/components/Modal/Add-Images.vue'
import DraggableTable from '@/components/draggable-table'
import DateTimePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import VCalendar from 'v-calendar'
import Card from '@/components/common/Card.vue'
import Content from '@/components/common/Content.vue'
import Status from '@/components/common/Status.vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VCalendar)

// Cấu hình default settings cho Select2
const defaultSelect2Settings = {
  language: {
    searching: function () {
      return 'Đang tìm kiếm...'
    },
    noResults: function () {
      return 'Không tìm thấy kết quả'
    },
    inputTooShort: function () {
      return 'Vui lòng nhập ít nhất 1 ký tự'
    },
    inputTooLong: function () {
      return 'Vui lòng xóa bớt ký tự'
    },
    loadingMore: function () {
      return 'Đang tải thêm kết quả...'
    },
    maximumSelected: function () {
      return 'Bạn chỉ có thể chọn tối đa số mục này'
    },
  },
}

// Hàm merge deep settings
function mergeDeep(target, source) {
  const output = Object.assign({}, target)
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] })
        } else {
          output[key] = mergeDeep(target[key], source[key])
        }
      } else {
        Object.assign(output, { [key]: source[key] })
      }
    })
  }
  return output
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

// Tạo wrapper component cho Select2 với default settings - WITH DEBUG
const Select2WithDefaults = {
  name: 'Select2WithDefaults',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Array, Object, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    mergedSettings() {
      const userSettings = this.settings || {}
      return mergeDeep(defaultSelect2Settings, userSettings)
    },
  },
  render(h) {
    const self = this
    return h(Select2, {
      props: {
        value: this.value,
        options: this.options,
        settings: this.mergedSettings,
        disabled: this.disabled,
        placeholder: this.placeholder,
        id: this.id,
        name: this.name,
      },
      on: {
        // Debug: log tất cả events
        input(val) {
          self.$emit('input', val)
        },
        select(val) {
          self.$emit('select', val)
        },
        change(val) {
          self.$emit('input', val)
          self.$emit('change', val)
          // Một số version của select2 dùng change thay vì input
        },
      },
      scopedSlots: this.$scopedSlots,
    })
  },
}

// Tạo wrapper component cho Select2MultipleControl với default settings - WITH DEBUG
const Select2MultipleControlWithDefaults = {
  name: 'Select2MultipleControlWithDefaults',
  inheritAttrs: false,
  props: {
    value: {
      type: [Array, String, Number, Object, Boolean],
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    mergedSettings() {
      const userSettings = this.settings || {}
      return mergeDeep(defaultSelect2Settings, userSettings)
    },
  },
  render(h) {
    const self = this
    return h(Select2MultipleControl, {
      props: {
        value: this.value,
        options: this.options,
        settings: this.mergedSettings,
        disabled: this.disabled,
        placeholder: this.placeholder,
        id: this.id,
        name: this.name,
      },
      on: {
        // Debug: log tất cả events
        input(val) {
          self.$emit('input', val)
        },
        select(val) {
          self.$emit('select', val)
        },
        change(val) {
          self.$emit('input', val)
          self.$emit('change', val)
          // Một số version của select2 dùng change thay vì input
        },
      },
      scopedSlots: this.$scopedSlots,
    })
  },
}

Vue.component('DraggableTable', DraggableTable)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('Select2', Select2WithDefaults)
Vue.component('select2', Select2) // Đăng ký cả kebab-case
Vue.component('DateRanger', DateRangePicker)
Vue.component('Datepicker', Datepicker)
Vue.component('Select2MultipleControl', Select2MultipleControl)
Vue.component('select2-multiple-control', Select2MultipleControl) // Đăng ký cả kebab-case
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('DateRangePicker', DateRangePicker)
Vue.component('VueLoadingOverlay', VueLoadingOverlayCustom)
Vue.component('NotiSuccess', NotiSuccess)
Vue.component('NotiError', NotiError)
Vue.component('AddImages', AddImages)
Vue.component('default-layout', Default)
Vue.component('login-layout', Login)
Vue.component('multiselect', Multiselect)
Vue.component('DateTimePicker', DateTimePicker)
Vue.component('Card', Card)
Vue.component('Content', Content)
Vue.component('Status', Status)

Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_API_TOKEN,
    libraries: 'places',
  },
})
